import React from "react";

export const REGION_NAMES = { 0: "Prizemlje", 1: "Terasa", 2: "Sprat", 3: "Smeštaj" };

/**
 * Table map: each region is a separate 1000x500 "canvas" (x: 0-999, y: 0-499, (0,0) top left),
 * tables are positioned absolutely by their local coordinates. Grouped by region because
 * coordinates do not carry across regions. Colors are semantic only: red occupied, green free.
 */
export default function TableMap({ tables, allTables = tables, onSelect }) {
  // Counters per region apply to ALL tables of the region; the map draws only those that pass the status filter.
  const allByRegion = allTables.reduce((acc, s) => {
    (acc[s.Region] = acc[s.Region] || []).push(s);
    return acc;
  }, {});
  const byRegion = tables.reduce((acc, s) => {
    (acc[s.Region] = acc[s.Region] || []).push(s);
    return acc;
  }, {});
  const regions = Object.keys(allByRegion)
    .map(Number)
    .sort((a, b) => a - b);

  if (regions.length === 0) {
    return <p className="py-6 text-center text-sm text-slate-500 dark:text-slate-400">Nema stolova za izabrani filter</p>;
  }

  return (
    <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
      {regions.map((region) => {
        const items = byRegion[region] || [];
        const all = allByRegion[region] || [];
        const occupied = all.filter((s) => s.Zauzet).length;
        return (
          <div key={region}>
            <div className="mb-2 flex items-baseline justify-between gap-3">
              <h4 className="text-sm font-semibold text-slate-800 dark:text-slate-100">
                {REGION_NAMES[region] || `Rejon ${region}`}
              </h4>
              <span className="text-xs tabular-nums text-slate-500 dark:text-slate-400">
                {occupied} od {all.length} zauzeto
              </span>
            </div>
            <div
              className="relative w-full overflow-hidden rounded-lg border border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-950/50"
              style={{ aspectRatio: "1000 / 500" }}
            >
              {items.map((table) => (
                <button
                  key={table.ID}
                  type="button"
                  onClick={() => onSelect(table)}
                  title={table.Sto}
                  aria-label={`Sto ${table.Sto}, ${table.Zauzet ? "zauzet" : "slobodan"}`}
                  style={{ left: `${(table.X / 1000) * 100}%`, top: `${(table.Y / 500) * 100}%` }}
                  className={`absolute flex h-5 w-5 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded border text-[6px] font-semibold
                    transition-transform duration-150 hover:z-10 hover:scale-110 active:scale-95
                    sm:h-10 sm:w-10 sm:rounded-md sm:text-[10px]
                    ${
                      table.Zauzet
                        ? "border-danger/70 bg-danger/10 text-danger-dark dark:border-danger-light/60 dark:bg-danger/20 dark:text-danger-light"
                        : "border-success/70 bg-success/10 text-success-dark dark:border-success-light/60 dark:bg-success/20 dark:text-success-light"
                    }`}
                >
                  {table.Sto}
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
